import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const RouteTracker = () => {
    const location = useLocation();

    const isProd = import.meta.env.PROD;

    const DEBUG = true;

    useEffect(() => {
        if (!isProd) return;

        if (typeof window.$wc_load !== 'function') {
            window.$wc_load = function (a) {
                return JSON.parse(JSON.stringify(a));
            };
        }

        if (!window.$wc_leads) {
            window.$wc_leads = {
                doc: {
                    url: window.$wc_load(document.URL),
                    ref: window.$wc_load(document.referrer),
                    search: window.$wc_load(window.location.search),
                    hash: window.$wc_load(window.location.hash)
                }
            };
        }

        const SCRIPT_SRC = "//s.ksrndkehqnwntyxlhgto.com/127113.js";
        const existingScript = document.querySelector(`script[src$="127113.js"]`);

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = SCRIPT_SRC;
            script.async = true;
            document.head.appendChild(script);
            if (DEBUG) console.log("[Tracking] Tracking script initialized.");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProd]);

    useEffect(() => {
        if (!isProd) return;

        if (window.$wc_leads && window.$wc_leads.doc && typeof window.$wc_load === 'function') {
            const timer = setTimeout(() => {
                window.$wc_leads.doc = {
                    url: window.$wc_load(window.location.href),
                    ref: window.$wc_load(document.referrer),
                    search: window.$wc_load(window.location.search),
                    hash: window.$wc_load(window.location.hash)
                };

                if (DEBUG) {
                    console.log("[Tracking] Route Change Detected. Data updated for:", window.location.pathname);
                }

                if (typeof window._wc_track === 'function') {
                    window._wc_track();
                }
            }, 0);

            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, isProd]);

    return null;
};

export default RouteTracker;
